import app from '@/app';
import templateUrl from './update-item-button.html';

app.component('prUpdateItemButton', {
	templateUrl,
	bindings: {
		isDisabled: '<',
		onClick: '&',
		readonly: '<'
	}
});
